<div class="relativePageContainer">
  <div #pageContainer class="page-container">
    <div [ngClass]="isDrawerOpen? '' : 'noShadowOverlay'" class="dx-card">
      <dx-drawer
        (onInitialized)="subscribeToWindowResize()"
        [(opened)]="isDrawerOpen"
        [className]="'drawerParent'"
        [closeOnOutsideClick]="false"
        [height]="'100%'"
        [openedStateMode]="'overlap'"
        [position]="'right'"
        [revealMode]="'expand'"
        [shading]="isEditMode"
        template="template">

        <!---------------------->
        <!--  Drawer content  -->
        <!---------------------->

        <div *dxTemplate="let data of 'template'" [style.width.px]="(pageContainer.offsetWidth - 20) * 0.8"
             class="drawerInnerContent flexColumn" style="border-radius: 10px; gap: 0">
          <div class="drawerTitleWrapper">
            <h2 *ngIf="!!selectedMetric && !!selectedMetric.id" class="partitionName">{{ selectedMetric!.name }}</h2>
            <h2 *ngIf="!selectedMetric || !selectedMetric.id"
                class="partitionName">{{ 'REGISTRY.VIRTUAL_METRICS.ADD_METRIC' | translate }}</h2>
            <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
              <dx-button (onClick)="enableEditMode()" *ngIf="!isEditMode" [type]="'default'" icon="edit"
                         id="editVirtualMetricButton"
                         text="{{'BUTTONS.UPDATE' | translate}}"></dx-button>
              <dx-button (onClick)="deleteVirtualMetric()" *ngIf="!isEditMode" icon="trash"
                         text="{{'BUTTONS.DELETE' | translate}}"
                         type="danger"></dx-button>
              <div *ngIf="isEditMode" style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                <dx-button (onClick)="saveVirtualMetric()"
                           [disabled]="!isEditFormValid" [stylingMode]="'contained'"
                           [type]="'default'" icon="save"
                           text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
                <dx-button
                  (onClick)="disableEditMode();" [type]="'normal'" [stylingMode]="'contained'" icon="revert"
                  text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
              </div>
              <dx-button (onClick)="closeDrawer()" *ngIf="!isEditMode" [type]="'default'"
                         [width]="30"
                         icon="close"></dx-button>
            </div>
          </div>


          <dx-tab-panel *ngIf="isDrawerOpen" [(selectedIndex)]="selectedTab" [animationEnabled]="true"
                        itemTitleTemplate="translatedTemplate"
                        style="height: 100%; display: flex;">

            <div *dxTemplate="let title of 'translatedTemplate'" class="flexRow">
              <span>{{ title.caption | translate }}</span>
              <ng-container *ngIf="title.caption === 'REGISTRY.VIRTUAL_METRICS.CONFIG_TAB'">
                <div *ngIf="isEditMode && (!isEditFormValid || !isExpressionValid)" class="invalidBadge">!</div>
              </ng-container>
            </div>

            <dxi-item caption="REGISTRY.VIRTUAL_METRICS.CONFIG_TAB" class="flexElement">

              <!------------------>
              <!--  Form Basic  -->
              <!------------------>
              <div class="flexFill flexColumn" style="padding: 20px; gap: 10px; overflow: hidden; height: 100%; ">

                <div style="overflow: visible; height: auto; flex: 0 1 auto">
                  <dx-form
                    #vmForm
                    (onFieldDataChanged)="validateForm()"
                    *ngIf="!!selectedMetric"
                    [(formData)]="selectedMetric"
                    [colCount]="12"
                    [disabled]="!isEditMode">
                    <dxi-item [colSpan]="3" dataField="name">
                      <dxo-label [text]="'REGISTRY.VIRTUAL_METRICS.NAME' | translate"></dxo-label>
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                      <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                                           [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                                           type="stringLength"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item [colSpan]="3" [editorOptions]="
                  {
                    disabled: !isNewVM || selectedMetric!.isResettable || !isEditMode,
                    dataSource: this.dataTypeValues,
                    displayExpr: translateLabel,
                    onValueChanged: setDataTypeValue,
                    valueExpr: 'value',
                  }"
                              dataField="dataType"
                              editorType="dxSelectBox">
                      <dxo-label [text]="'REGISTRY.VIRTUAL_METRICS.DATA_TYPE_LABEL' | translate"></dxo-label>
                    </dxi-item>
                    <dxi-item [colSpan]="3" [editorOptions]="
                                                {
                                                  dataSource: this.dataUnitValues,
                                                  displayExpr: 'name',
                                                  disabled: selectedMetric!.isBool || !isEditMode,
                                                  searchEnabled: true,
                                                  acceptCustomValue: true,
                                                  onCustomItemCreating: addNewDataUnit,
                                                  valueExpr: 'id',
                                                  itemTemplate: 'dataUnitItemTemplate',
                                                }"
                              dataField="dataUnit.id"
                              editorType="dxSelectBox"
                    >
                      <dxo-label [text]="'REGISTRY.VIRTUAL_METRICS.DATA_UNIT' | translate"></dxo-label>
                    </dxi-item>
                    <div *dxTemplate="let data of 'dataUnitItemTemplate'" class="custom-item">
                      <div class="manufacturer-item">
                        <span>{{ data.name }}</span>
                        <dx-button (onClick)="deleteDataUnit(data, $event)" icon="trash" stylingMode="text"
                                   type="default"></dx-button>
                      </div>
                    </div>
                    <dxi-item [colSpan]="3" [editorOptions]="
                {
                  max: 10,
                  min: 0,
                  step: 1,
                  disabled: selectedMetric!.isBool,
                  showSpinButtons: true
                }"
                              dataField="decimalDigits"
                              editorType="dxNumberBox">
                      <dxo-label [text]="'REGISTRY.VIRTUAL_METRICS.DECIMAL_DIGITS' | translate"></dxo-label>
                    </dxi-item>

                  </dx-form>
                  <div *ngIf="!!selectedMetric" class="flexRow" style="gap: 25px;">

                <span class="flexRow">
                  <span>{{ 'REGISTRY.VIRTUAL_METRICS.ENABLED' | translate }}:</span>
                  <dx-switch [(value)]="selectedMetric.enabled" [disabled]="!isEditMode">
                  </dx-switch>
                </span>
                    <span *ngIf="selectedMetric.isResettable !== undefined" class="flexRow">
                      <span>{{ 'REGISTRY.VIRTUAL_METRICS.IS_RESETTABLE' | translate }}:</span>
                  <dx-switch (onValueChanged)="initializeDetailForm($event)"
                             [(value)]="selectedMetric.isResettable"
                             [disabled]="!isNewVM || !isEditMode">
                  </dx-switch>
                </span>
                  </div>
                </div>

                <!--------------------->
                <!--  Form Advanced  -->
                <!--------------------->

                <div *ngIf="!!selectedMetric" class="dx-card flat flexFill flexColumn"
                     style="padding: 20px; overflow: hidden; height: auto;">

                  <ng-container
                    *ngIf="!!selectedMetric.scheduledConfig && selectedMetric.type === VMTypeEnum.SCHEDULED">

                    <app-cron-input
                      [(value)]="selectedMetric.scheduledConfig.cronExpression"
                      [disabled]="!isEditMode">
                    </app-cron-input>
                  </ng-container>


                  <ng-container
                    *ngIf="!!selectedMetric.resettableConfig && selectedMetric.type === VMTypeEnum.RESETTABLE">

                    <div class="flexRow">
                      <span>{{ 'REGISTRY.VIRTUAL_METRICS.ACCUMULATE' | translate }}</span>
                      <dx-switch [(value)]="selectedMetric.resettableConfig.accumulate"
                                 [disabled]="!isEditMode"></dx-switch>
                    </div>

                    <dx-select-box
                      [(value)]="selectedMetric.resettableConfig.resetInterval"
                      [dataSource]="vmResetIntervalValues"
                      [disabled]="!isEditMode"
                      [displayExpr]="translateResetIntervals"
                      class="flexFill"
                      label=" {{ 'REGISTRY.VIRTUAL_METRICS.RESET_INTERVAL' | translate }} ">
                    </dx-select-box>

                  </ng-container>

                  <div class="flexRow" style="align-items: baseline">
                    <dx-text-box
                      #expressionField
                      (onValueChanged)="isExpressionValid = false"
                      [(value)]="selectedMetric.expression"
                      [disabled]="!isEditMode"
                      [valueChangeEvent]="'keyup'"
                      class="flexFill"
                      id="expressionField"
                      label="{{ 'REGISTRY.VIRTUAL_METRICS.EXPRESSION' | translate }}">
                      <dxi-button
                        [options]="operationsTooltipButton"
                        location="before"
                        name="operations">
                      </dxi-button>
                      <dx-validator>
                      </dx-validator>
                    </dx-text-box>
                    <dx-button
                      (onClick)="validateExpression()"
                      [disabled]="!(isEditMode && !isExpressionValid) || this.selectedMetrics.length === 0"
                      [height]="32"
                      [icon]="'taskcomplete'"
                      text="{{ 'REGISTRY.VIRTUAL_METRICS.VALIDATE_EXPRESSION' | translate }}">
                    </dx-button>

                    <dx-popover
                      [(visible)]="operationsTooltipVisible"
                      target="#expressionField">
                      <div *dxTemplate="let data of 'content'">
                        <p>{{ 'REGISTRY.VIRTUAL_METRICS.POSSIBLE_EXPRESSIONS' | translate }}<br/><code>+, - , *, /, ^,
                          %, ==, !=, !, >, >=, <, <=,<br/>&&, ||, ABS(), SQRT(), SIN(), LOG()</code><br/><a
                          (click)="openExpressionDocPopup()"
                          style="cursor: pointer">{{ 'REGISTRY.VIRTUAL_METRICS.EXPRESSIONS_DOC' | translate }}</a>
                        </p>
                      </div>
                      <dxo-position
                        at="left bottom"
                        my="left top"
                        of="#expressionField"
                      ></dxo-position>
                    </dx-popover>


                  </div>

                  <dx-data-grid
                    #inputMetricsDataGrid
                    (onEditorPreparing)="onEditorPreparingMetric($event)"
                    (onRowPrepared)="colorResettableRows($event)"
                    (onRowRemoved)="validateForm()"
                    [columnAutoWidth]="true"
                    [dataSource]="selectedMetrics"
                    [disabled]="!isEditMode"
                    [showBorders]="true"
                    [showRowLines]="false"
                    [wordWrapEnabled]="true"
                    class="flexFill"
                    height="100%"
                    keyExpr="uuid">

                    <dxo-row-dragging
                      [allowReordering]="true"
                      [onReorder]="onReorder">
                    </dxo-row-dragging>

                    <dxo-editing
                      [allowDeleting]="true"
                      [allowUpdating]="true"
                      [confirmDelete]="false">
                    </dxo-editing>

                    <dxo-toolbar>
                      <dxi-item location="before">
                        <p
                          style="font-size: 22px; margin: 0 0 0 10px; white-space: nowrap;">{{ 'REGISTRY.VIRTUAL_METRICS.METRICS' | translate }}</p>
                      </dxi-item>
                      <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
                      </dxi-item>
                      <dxi-item location="after">
                        <div *dxTemplate="let data of 'content'">
                          <dx-button (onClick)="goToMetricsTab()" hint="{{'BUTTONS.HINTS.ADD' | translate}}"
                                     icon="add"
                                     stylingMode="text">
                            <i class="vr-ic_fluent_add_24_regular"></i>
                          </dx-button>
                        </div>
                      </dxi-item>
                    </dxo-toolbar>
                    <dxo-paging
                      [enabled]="false">
                    </dxo-paging>

                    <dxo-scrolling
                      mode="standard">
                    </dxo-scrolling>

                    <dxi-column caption="{{'REGISTRY.VIRTUAL_METRICS.TABLE.ALIAS' | translate}}" dataField="alias">
                      <dxi-validation-rule type="required"></dxi-validation-rule>
                      <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                                           [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                                           type="stringLength"></dxi-validation-rule>
                      <dxi-validation-rule [validationCallback]="validateAliasUniqueness"
                                           message="{{ 'REGISTRY.VIRTUAL_METRICS.TABLE.DUPLICATE_ALIAS' | translate }}"
                                           type="custom"></dxi-validation-rule>
                    </dxi-column>
                    <dxi-column [allowEditing]="false" [cellTemplate]="'fullMetricNameTemplate'"
                                [editCellTemplate]="'disabledCellEditTemplate'"
                                caption="{{'REGISTRY.VIRTUAL_METRICS.TABLE.NAME' | translate}}"
                                dataField="fullMetricInstance">
                    </dxi-column>

                    <div *dxTemplate="let cellInfo of 'fullMetricNameTemplate'">
                      {{ composeFullMetricName(cellInfo.value) }}
                    </div>

                    <dxi-column [allowEditing]="selectedMetric.type === VMTypeEnum.SCHEDULED"
                                [cellTemplate]="'valueTypeTemplate'"
                                [setCellValue]="updateMetricOnChange"
                                caption="{{'REGISTRY.VIRTUAL_METRICS.TABLE.AGGREGATE' | translate}}"
                                dataField="valueType">
                      <dxo-lookup
                        [dataSource]="metricValueType"
                        [displayExpr]="parseMetricValueType">
                      </dxo-lookup>
                    </dxi-column>

                    <div *dxTemplate="let cellInfo of 'valueTypeTemplate'">
                      {{ parseMetricValueType(cellInfo.value) }}
                    </div>

                    <div *dxTemplate="let cellInfo of 'disabledCellEditTemplate'"
                         style="color: darkgray; padding: 10px 11px;">
                      {{ cellInfo.value }}
                    </div>

                    <!--                <ng-container *ngIf="enableAdvancedCronSelection && this.selectedMetric!.type === VMTypeEnum.SCHEDULED">-->
                    <dxi-column [editorOptions]="{min: 1}"
                                caption="{{'REGISTRY.VIRTUAL_METRICS.TABLE.BUCKET_VALUE' | translate}}"
                                cellTemplate="bucketValue"
                                dataField="aggregateInfo.bucketValue"
                                dataType="number">
                    </dxi-column>

                    <div *dxTemplate="let column of 'bucketValue'">
                      <div [ngClass]="{'disabledColumn': this.selectedMetric!.type === VMTypeEnum.RESETTABLE}">
                        {{ column.value }}
                      </div>
                    </div>

                    <dxi-column caption="{{'REGISTRY.VIRTUAL_METRICS.TABLE.BUCKET_UNITS' | translate}}"
                                cellTemplate="bucketUnits"
                                dataField="aggregateInfo.bucketUnits">
                      <dxo-lookup [dataSource]="timeUnitValues" [displayExpr]="getAcquisitionCronLabel">
                      </dxo-lookup>
                    </dxi-column>

                    <div *dxTemplate="let column of 'bucketUnits'">
                      <div [ngClass]="{'disabledColumn': this.selectedMetric!.type === VMTypeEnum.RESETTABLE}">
                        {{ getAcquisitionCronLabel(column.value) }}
                      </div>
                    </div>

                    <dxi-column caption="{{'REGISTRY.VIRTUAL_METRICS.TABLE.AGGREGATION_FUNCTION' | translate}}"
                                cellTemplate="aggregateFunction"
                                dataField="aggregateInfo.aggregateFunction">
                      <dxo-lookup [dataSource]="functionTypesValues" [displayExpr]="translateFunctionType">
                      </dxo-lookup>

                    </dxi-column>

                    <div *dxTemplate="let column of 'aggregateFunction'">
                      <div [ngClass]="{'disabledColumn': this.selectedMetric!.type === VMTypeEnum.RESETTABLE}">
                        {{ translateFunctionType(column.value) }}
                      </div>
                    </div>

                    <dxi-column [editorOptions]="{min: 1, max: 100}"
                                caption="{{'REGISTRY.VIRTUAL_METRICS.TABLE.SAMPLE_PERCENTAGE' | translate}}"
                                cellTemplate="samplePercentage"
                                dataField="aggregateInfo.samplePercentage"
                                dataType="number">

                    </dxi-column>

                    <div *dxTemplate="let column of 'samplePercentage'">
                      <div [ngClass]="{'disabledColumn': this.selectedMetric!.type === VMTypeEnum.RESETTABLE}">
                        {{ column.value }}
                      </div>
                    </div>


                  </dx-data-grid>

                </div>

              </div>
            </dxi-item>
            <dxi-item [disabled]="!isEditMode" caption="REGISTRY.VIRTUAL_METRICS.METRICS_TAB" class="flexElement">
              <div class="metricsFormBody">
                <div class="flexRow">
                  <app-partition-selector
                    [(selectedPartition)]="dashboardService.selectedPartitionIds[0]"
                    class="flexFill">
                  </app-partition-selector>

                </div>

                <div *ngIf="partitionIsNotVisible()">
                  <span style="color: var(--keton-alarm-offline);
                        font-size: 14px;">{{ getPartitionErrorMessage() }}</span>
                </div>

                <div class="absoluteWrapper">
                  <div class="sideBySideLists absoluteFill">
                    <app-device-selector
                      #deviceSelectorComponent
                      [(selectedDeviceId)]="dashboardService.selectedDeviceIds[0]"
                      [selectedPartitionId]="dashboardService.selectedPartitionIds[0]">
                    </app-device-selector>
                    <app-metric-selector
                      (newSelectedMetric)="convertSelectedMetric($event); validateForm(); isExpressionValid = false;"
                      [deviceList]="deviceSelectorComponent.deviceList"
                      [forbidSVM]="true"
                      [forbiddenDataTypes]="[DataTypeGroupEnum.STRING]"
                      [inputDisplayMode]="'table'"
                      [selectedDeviceId]="dashboardService.selectedDeviceIds[0]"
                      [selectedPartitionId]="dashboardService.selectedPartitionIds[0]">
                    </app-metric-selector>
                  </div>
                </div>
              </div>
            </dxi-item>
          </dx-tab-panel>

        </div>

        <!-------------------->
        <!--  Page content  -->
        <!-------------------->

        <div class="drawerOuterContent">

          <div *ngIf="!this.selectedPartitionId && this.selectedPartitionId !== 0"
               style="position: relative; top: 50%; transform: translate(0, -50%); display: flex; flex-direction: column; align-items: center; gap: 10px; justify-content: center;">
            <label style="font-size: 24px">{{ 'REGISTRY.VIRTUAL_METRICS.TEXT.SELECT_PARTITION' | translate }}</label>
          </div>

          <dx-data-grid
            id="virtualMetricsDataGrid"
            (onRowClick)="onVirtualMetricRowClick($event)"
            *ngIf="!!this.selectedPartitionId || this.selectedPartitionId === 0"
            [columnAutoWidth]="true"
            [dataSource]="virtualMetrics"
            [showBorders]="true"
            [showRowLines]="false"
            [wordWrapEnabled]="true"
            height="100%"
            keyExpr="id">

            <dxo-scrolling
              [rowRenderingMode]="'virtual'">
            </dxo-scrolling>

            <dxo-selection
              [mode]="'single'"
              [selectByClick]="true"
              [showCheckBoxesMode]="'none'">
            </dxo-selection>

            <dxo-toolbar>
              <dxi-item location="before">
                <p
                  style="font-size: 22px; margin: 0 0 0 10px; white-space: nowrap;">{{ 'MENU_VOICE.REGISTRY.VIRTUAL_METRICS' | translate }}</p>
              </dxi-item>
              <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
              </dxi-item>
              <dxi-item location="before">
                <div *dxTemplate="let data of 'content'">
                  <dx-button (onClick)="showNewVirtualMetricForm()" [disabled]="selectedPartitionId === undefined"
                             hint="{{'BUTTONS.HINTS.ADD' | translate}}" icon="add"
                             stylingMode="text">
                    <i class="vr-ic_fluent_add_24_regular"></i>
                  </dx-button>
                </div>
              </dxi-item>
            </dxo-toolbar>

            <dxo-paging
              [enabled]="false">
            </dxo-paging>

            <dxo-scrolling
              mode="standard">
            </dxo-scrolling>

            <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}"></dxo-search-panel>

            <dxi-column caption="{{ 'REGISTRY.VIRTUAL_METRICS.NAME' | translate}}" dataField="name"></dxi-column>
            <dxi-column [calculateDisplayValue]="translateVirtualMetricType"
                        caption="{{ 'REGISTRY.VIRTUAL_METRICS.TYPE' | translate}}"
                        dataField="type"></dxi-column>
            <dxi-column caption="{{ 'REGISTRY.VIRTUAL_METRICS.ENABLED' | translate}}" dataField="enabled"></dxi-column>
            <dxi-column [calculateDisplayValue]="parseLastValue" [showEditorAlways]="false"
                        caption="{{ 'REGISTRY.VIRTUAL_METRICS.LAST_VALUE' | translate}}"
                        dataField="lastValue"></dxi-column>
            <dxi-column caption="" cellTemplate="actionsTemplate" type="buttons"></dxi-column>

            <div *dxTemplate="let data of 'actionsTemplate'" style="display: flex; justify-content: center; gap: 10px">
              <i (click)="$event.stopPropagation(); openDuplicateVirtualMetric(data.data);"
                 [matTooltip]="'REGISTRY.VIRTUAL_METRICS.TOOLTIP.DUPLICATE' | translate"
                 class="dx-icon-copy custom-action-icon"></i>
            </div>

          </dx-data-grid>

          <dx-popup
            (onHiding)="duplicatingMetric = undefined"
            [dragEnabled]="false"
            [focusStateEnabled]="false"
            [fullScreen]="appService.isSmallScreen()"
            [height]="220"
            [hideOnOutsideClick]="true"
            [showCloseButton]="false"
            [showTitle]="true"
            [title]="'REGISTRY.VIRTUAL_METRICS.TEXT.DUPLICATE_VM' | translate"
            [visible]="!!duplicatingMetric"
            [width]="660">
            <dxi-toolbar-item
              location="after"
              toolbar="bottom">
              <dx-button
                (onClick)="duplicateVirtualMetric()"
                [disabled]="!duplicateMetricName"
                [height]="40"
                [stylingMode]="'contained'"
                icon="copy"
                text="{{'REGISTRY.VIRTUAL_METRICS.BUTTONS.DUPLICATE' | translate}}"
                type="default">
              </dx-button>
            </dxi-toolbar-item>
            <dxi-toolbar-item
              location="after"
              toolbar="bottom">
              <dx-button
                (onClick)="duplicatingMetric = undefined"
                [height]="40"
                [stylingMode]="'outlined'"
                icon="close"
                text="{{'BUTTONS.CANCEL' | translate}}">
              </dx-button>
            </dxi-toolbar-item>

            <div style="height: 100%; display: flex; align-items: center;">
              <dx-text-box
                [(value)]="duplicateMetricName"
                [label]="'REGISTRY.VIRTUAL_METRICS.TEXT.DUPLICATE_VM_NAME_LABEL' | translate"
                [maxLength]="gmService.STR_DIM_MID"
                style="width: 100%;">
              </dx-text-box>
            </div>
          </dx-popup>
        </div>

      </dx-drawer>
    </div>
  </div>
</div>

<dx-popup
  [(visible)]="expressionDocPopupOpened"
  [dragEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [hideOnOutsideClick]="true"
  title="{{ 'REGISTRY.VIRTUAL_METRICS.EXPRESSIONS_DOC' | translate }}">

  <app-expression-functions></app-expression-functions>

</dx-popup>
